import { SetLoadedAction } from '@customTypes/ActionTypes';

export function setLoaded() : SetLoadedAction {
    return {
        type: 'SET_LOADED'
    };
}
